module.exports = __webpack_public_path__ + "static/media/documents-recycle-white.68a1c6e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/documents-recycle-white.svg
// module id = 1499
// module chunks = 0